module.exports = __webpack_public_path__ + "img/m_photo_.4d3ec23d.png";